import React from 'react';
import { createTheme } from '@mui/material/styles';
import '@mui/x-date-pickers-pro/themeAugmentation';
import { KARLA_FONT_FAMILY } from 'libs/end-to-end/src/types/branding/fonts';
import { CheckmarkCheckedIcon } from 'apps/sigma2-ui/src/components/svg/CheckmarkIcon';
import { CheckmarkUncheckedIcon } from 'apps/sigma2-ui/src/components/svg/CheckmarkIcon';

export const S2Theme = createTheme({
  typography: {
    fontFamily: KARLA_FONT_FAMILY,
  },
  components: {
    MuiDateCalendar: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiMonthCalendar: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiYearCalendar: {
      styleOverrides: {
        root: {
          width: '100%',
        },
      },
    },
    MuiToggleButton: {
      styleOverrides: {
        root: {
          '&.MuiToggleButton-success': {
            color: '#2e7d32', // MUI success main color
            borderColor: '#4caf50', // MUI success light color
            '&:hover': {
              backgroundColor: 'rgba(76, 175, 80, 0.08)', // success light with opacity
              borderColor: '#4caf50',
            },
            '&.Mui-selected': {
              backgroundColor: '#4caf50', // MUI success light color
              color: '#fff',
              '&:hover': {
                backgroundColor: '#66bb6a', // MUI success lighter
              },
            },
          },
        },
      },
    },
    MuiInputLabel: {
      defaultProps: {
        shrink: true,
      },
      styleOverrides: {
        root: {
          fontFamily: KARLA_FONT_FAMILY,
          fontWeight: 400,
          fontSize: 14,
          color: '#292D33',

          '&.MuiInputLabel-shrink': {
            transform: 'translate(0, 0) scale(1)',
          },
          '.MuiFormControl-root:has(.MuiSelect-root)': {
            color: '#696D70',
          },
          '.MuiFormControl-root:has(.MuiSelect-root) &.MuiInputLabel-shrink': {
            transform: 'translate(14px, 7px) scale(0.85)',
          },
        },
      },
    },
    MuiFormControl: {
      styleOverrides: {
        root: {
          /* outlined TextField with label, but NOT select */
          '&:has(.MuiOutlinedInput-root):has(.MuiInputLabel-root):not(:has(.MuiSelect-root))':
            {
              paddingTop: 22,
            },

          /* standard TextField with label, but NOT select */
          '&:has(.MuiInput-root):has(.MuiInputLabel-root):not(:has(.MuiSelect-root))':
            {
              paddingTop: 18,
            },
        },
      },
    },
    MuiOutlinedInput: {
      defaultProps: {
        notched: false,
      },
      styleOverrides: {
        root: {
          fontFamily: KARLA_FONT_FAMILY,
          fontWeight: 400,
          fontSize: 16,
          backgroundColor: '#fff',
          color: 'rgb(41, 45, 51)',
          '& .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
          },

          '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderWidth: 1,
          },

          '&.Mui-error .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d32f2f', // MUI error.main
          },

          '&.Mui-error.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: '#d32f2f',
          },
        },

        input: {
          fontFamily: KARLA_FONT_FAMILY,
          fontWeight: 400,
          fontSize: 16,
          '::placeholder': {
            color: '#6b7280',
            opacity: 1,
          },
        },
      },
    },

    MuiInput: {
      styleOverrides: {
        root: {
          fontFamily: KARLA_FONT_FAMILY,
          fontWeight: 400,
          fontSize: 16,
          color: 'rgb(41, 45, 51)',
        },

        input: {
          fontFamily: KARLA_FONT_FAMILY,
          fontWeight: 400,
          fontSize: 16,
          '::placeholder': {
            color: '#6b7280',
            opacity: 1,
          },
        },
      },
    },

    MuiSelect: {
      defaultProps: {
        notched: false,
      },
      styleOverrides: {
        root: {
          fontFamily: KARLA_FONT_FAMILY,
          fontWeight: 400,
          fontSize: 14,
        },
        select: {
          fontFamily: KARLA_FONT_FAMILY,
          fontWeight: 400,
          fontSize: 14,
          paddingTop: 27,
          paddingBottom: 10,
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          paddingTop: 8,
          fontSize: 14,
          marginLeft: 0,
          color: '#374151',
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: {
          fontFamily: KARLA_FONT_FAMILY,
          fontWeight: 500,
          fontSize: 16,
          marginLeft: 8,
        },
        root: {
          marginLeft: 0,
          marginRight: 0,
        },
      },
    },
    MuiCheckbox: {
      defaultProps: {
        icon: <CheckmarkUncheckedIcon />,
        checkedIcon: <CheckmarkCheckedIcon />,
      },
      styleOverrides: {
        root: {
          '&.Mui-checked': {
            color: 'currentColor',
          },
        },
      },
    },
  },
});
